import { InternalAxiosRequestConfig } from 'axios'

const CONTENT_TYPE_HEADER_NAME = 'Content-Type'

export const getDefaultHeaders = async (config: InternalAxiosRequestConfig) => {
  const { [CONTENT_TYPE_HEADER_NAME]: contentType, ...restHeaders } = config.headers

  return {
    ...config,
    headers: {
      Accept: 'application/json',
      [CONTENT_TYPE_HEADER_NAME]: contentType ?? 'application/json',
      ...restHeaders,
    },
  } as InternalAxiosRequestConfig
}
